import forge from 'node-forge';

const { pki } = forge;
const { rsa } = pki;

export class RSAKeyPair {
  constructor({ privateKey, publicKey } = {}) {
    this.privateKey = privateKey;
    this.publicKey = publicKey;
  }

  static GenerateKeyPair() {
    const { privateKey, publicKey } = rsa.generateKeyPair({ bits: 2048, e: 0x10001 });

    return new RSAKeyPair({ privateKey, publicKey });
  }

  static ImportPublicKey(pemPublicKey, { addHeaderAndFooter = false } = {}) {
    const pemKey = addHeaderAndFooter
      ? `-----BEGIN PUBLIC KEY-----\r\n${pemPublicKey}\r\n-----END PUBLIC KEY-----\r\n`
      : pemPublicKey;

    return new RSAKeyPair({ publicKey: pki.publicKeyFromPem(pemKey) });
  }

  static ImportPrivateKey(pemPrivateKey) {
    const privateKey = pki.privateKeyFromPem(pemPrivateKey);
    const publicKey = pki.setRsaPublicKey(privateKey.n, privateKey.e);

    return new RSAKeyPair({
      privateKey,
      publicKey,
    });
  }

  getPrivateKey() {
    return pki.privateKeyToPem(this.privateKey);
  }

  getPublicKey({ trimHeaderAndFooter = false } = {}) {
    const pemPublicKey = pki.publicKeyToPem(this.publicKey);
    if (trimHeaderAndFooter) {
      return pemPublicKey
        .replace('-----BEGIN PUBLIC KEY-----', '')
        .replace('-----END PUBLIC KEY-----', '')
        .replace(/\n/g, '')
        .replace(/\r/g, '');
    }
    return pemPublicKey;
  }

  decryptWithPrivateKey(data) {
    if (!this.privateKey) {
      throw new Error('private key not available');
    }
    const base64Encoded = forge.util.decodeUtf8(data);
    const encryptedData = forge.util.decode64(base64Encoded);
    return this.privateKey.decrypt(encryptedData);
  }

  encryptWithPublicKey(data) {
    const encrypted = this.publicKey.encrypt(window.Buffer.from(data));
    const base64Encoded = forge.util.encode64(encrypted);
    return forge.util.encodeUtf8(base64Encoded);
  }
}

export default {
  RSAKeyPair,
};
